import router from '@/router';
import { usePUserStore } from '@/store';
import { isWhiteUrl } from '@/utils/is-white-url';
import { showLoginHandler } from '@/utils/login-by-env';
import { setApiCustomConfig } from '@vas2t-lowcode/api';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css';
import { getEnv } from '../../env';

export function configApi() {
  const userStore = usePUserStore();
  const baseURL = getEnv(import.meta.env).baseApi;
  // 配置api
  setApiCustomConfig({
    utils: {
      timeMin4Sentry: 3e3,
      timeMax4Sentry: 5e3,
      elMessage: ElMessage,
    },
    baseURL,
    toLoginPageAsync() {
      return new Promise((resolve) => {
        /**
         * 登录页跳转 - 异步
         */
        const route = router.currentRoute.value;
        if (!isWhiteUrl(route.name)) {
          // 设置 lastUrl
          userStore.lastUrl = location.href;
          showLoginHandler();
        }
        resolve();
      });
    },
    cb4Logout() {
      // 退出登录，清除相关数据
      userStore.removeLoginInfo();
      userStore.initState();
    },
  });
}
